import React from 'react';
import { Form } from 'react-bootstrap';
import { FormLabel } from '../forms';

interface FileSelectProps {
  name: string;
  acceptType?: string;
  label?: string;
  onChange?: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  required?: boolean;
}

export const FileSelect: React.FC<FileSelectProps> = ({
  name,
  acceptType,
  label,
  onChange,
  required
}) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.currentTarget.files?.[0] || null;
    onChange?.(name, file);
  };

  return (
    <>
      {label ? <FormLabel required={required}>{label}</FormLabel> : <></>}
      <Form.Control
        name={name}
        type="file"
        size="sm"
        accept={acceptType ?? '*'}
        onChange={handleFileChange}
        aria-required={required || undefined}
      />
    </>
  );
};
